var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('doughnut-chart',{staticClass:"mb-6",attrs:{"height":400,"chart-data":_vm.chartData,"options":_vm.chartOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }